import { Typography, Container } from '@mui/material';

export default function OurLocation() {
  return (
    <Container maxWidth="md">
      <Typography variant="h6" sx={{ color: 'gray' }}>
        አድራሻችን
      </Typography>

      <Typography variant="h6" sx={{ pl: 2, color: 'darkgray' }}>
        ኢትዮጵያ ፣ አማራ ፣ ሰሜን ሸዋ ፣ ደብረ ብርሃን
      </Typography>

      <Typography variant="h6" sx={{ color: 'gray' }}>
        አቅጣጫ
      </Typography>
      <Typography variant="h6" sx={{ pl: 2, color: 'darkgray' }}>
        MGHM+R2W, Debre Birhan
      </Typography>

      <Typography variant="h6" sx={{ color: 'gray' }}>
        ጽ/ቤት
      </Typography>
      <Typography variant="h6" sx={{ pl: 2, color: 'darkgray' }}>
        ደብረ ብርሃን ቅድስት ሥላሴ ቤተክርስቲያን
      </Typography>
      <Typography variant="h6" sx={{ color: 'gray' }}>
        ስልክ
      </Typography>
      <Typography variant="h6" sx={{ pl: 2, color: 'darkgray' }}>
        +251 __ ___ ____
      </Typography>
      <Typography variant="h6" sx={{ color: 'gray' }}>
        P.O.X
      </Typography>
      <Typography variant="h6" sx={{ pl: 2, color: 'darkgray' }}>
        ________
      </Typography>
    </Container>
  );
}
